import React from 'react';
//components
import Dropdown from 'react-bootstrap/Dropdown';
import HeaderDropdown from './HeaderDropdown';
import HeaderGlobal from './HeaderGlobal';
import Image from '../image/Image';
import SearchForm from '../search-form/SearchForm';
//data
import { menus } from '../../content/header';
import { IMenu, menuIdNames } from '../../interfaces/header';
//images
import logo from '../../graphics/logo-experian.svg';
//styles
import './styles/header-main-common.scss';
import './styles/header-full.scss';

type HeaderFullProps = {};
type HeaderFullState = {
  isMobileToggleOn: boolean;
  showOverlay: boolean;
  mobSubMenu: boolean;
  rpt: boolean;
  itp: boolean;
  crd: boolean;
  lns: boolean;
  aut: boolean;
  mon: boolean;
  searchDrp: boolean;
};
class HeaderFull extends React.Component<HeaderFullProps, HeaderFullState> {
  constructor(props: HeaderFullProps) {
    super(props);
  }
  state = {
    isMobileToggleOn: false,
    showOverlay: false,
    mobSubMenu: false,
    rpt: false,
    itp: false,
    crd: false,
    lns: false,
    aut: false,
    mon: false,
    searchDrp: false,
  };
  handleNavToggleClick = () => {
    this.closeAllNavDropdowns();
    this.setState(() => ({
      mobSubMenu: false,
    }));
    this.setState((prevState) => ({
      isMobileToggleOn: !prevState.isMobileToggleOn,
    }));
  };
  checkOverlay = () => {
    let state = false;
    menus.forEach((st: IMenu) => {
      if (this.state[st.id]) {
        state = true;
        return;
      }
    });
    return state;
  };
  setToggleDropdown = (state: menuIdNames) => {
    this.setState((prevState) => ({
      mobSubMenu: !prevState[state],
    }));
    this.setState(
      (prevState) =>
        ({
          [state]: !prevState[state],
        }) as Pick<HeaderFullState, keyof HeaderFullState>,
      () => {
        this.showOverlay(this.checkOverlay());
      },
    );
    // to close search dropdown on desktop if open
    if (this.state.searchDrp) {
      this.setState(() => ({
        searchDrp: false,
      }));
    }
  };
  closeAllNavDropdowns(id?: menuIdNames) {
    if (!id) {
      this.showOverlay(false);
    }
    menus.forEach((st: IMenu) => {
      if (!id || st.id != id) {
        this.setState({
          [st.id]: false,
        } as Pick<HeaderFullState, keyof HeaderFullState>);
      }
    });
  }

  showOverlay(statement: boolean) {
    this.setState(() => ({
      showOverlay: statement,
    }));
  }
  render() {
    return (
      <>
        <div
          id="nav-overlay"
          className={`${this.state.showOverlay ? 'overlay' : ''}`}></div>

        <header
          id="header"
          className={`${this.state.isMobileToggleOn ? 'mob-open' : ''} ${
            this.state.mobSubMenu ? 'mob-sub-open' : ''
          }`}>
          <div className="container d-flex justify-content-between align-items-center nav-mobile d-lg-none py-2">
            <a
              href="/"
              className="exp-logo">
              <Image
                src={logo}
                alt="Experian logo."
                width="111"
                height="38"
              />
            </a>
            <div>
              <a href="/help/login.html">Sign In</a>
              <button
                aria-label="Mobile Navigation Button"
                className="btn nav-toggle ecs-font-icon-nav-menu py-0 pe-0"
                aria-expanded="false"
                aria-controls="nav-full"
                onClick={this.handleNavToggleClick}></button>
            </div>
          </div>
          <nav
            id="nav-full"
            className="d-flex flex-lg-wrap flex-column flex-lg-row align-items-start">
            <div className="container justify-content-between mobile-top-search order-1 py-3 border-bottom d-lg-none w-100 align-self-start align-self-lg-baseline align-items-start">
              <button
                className="nav-toggle btn order-2 ecs-font-icon-act-close py-0 pe-0"
                aria-controls="nav-full"
                aria-label="Close navigation"
                aria-expanded="true"
                onClick={this.handleNavToggleClick}></button>
              <div className="w-100">
                <SearchForm
                  toShowCopyOnFocus={true}
                  ifFocusableOnLoad={false}
                  className="border rounded order-1 flex-fill"
                  id="mob-nav-search"
                />
              </div>
            </div>
            <div
              id="main-navigation"
              className="w-100 align-self-lg-baseline order-2">
              <div className="container">
                <a
                  href="#main"
                  className="visually-hidden-focusable bg-white p-0 m-0 position-absolute">
                  Skip to main content
                </a>
                <div className="col d-lg-flex justify-content-lg-between align-items-lg-center position-relative">
                  <div className="d-lg-flex align-items-lg-center">
                    <a
                      href="/"
                      className="me-lg-4 exp-logo">
                      <Image
                        src={logo}
                        alt="Experian logo."
                        width="145"
                        height="49"
                      />
                    </a>
                    <ul className="main-nav-1 d-flex flex-wrap flex-lg-nowrap mb-0 ps-0">
                      {menus.map((menu) => (
                        <li key={`header-${menu.id}-li`}>
                          <Dropdown
                            show={this.state[menu.id]}
                            autoClose="outside"
                            className="position-static"
                            focusFirstItemOnShow="keyboard"
                            onToggle={() => {
                              this.setToggleDropdown(menu.id);
                            }}>
                            <Dropdown.Toggle
                              as="button"
                              id={menu.id}
                              aria-label={menu.titleCopy}
                              className={`${
                                this.state[menu.id] ? 'active-link' : ''
                              } m-n-link reset-btn`}
                              onClick={() => {
                                this.setToggleDropdown(menu.id);
                              }}>
                              {menu.titleCopy}
                            </Dropdown.Toggle>
                            <Dropdown.Menu renderOnMount={true}>
                              <HeaderDropdown
                                menu={menu}
                                backToMenu={this.setToggleDropdown}
                              />
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="main-nav-2 d-none d-lg-flex align-items-lg-center">
                    <a
                      href="/help/login.html"
                      className="login">
                      Sign In
                    </a>
                    <Dropdown
                      autoClose="outside"
                      show={this.state.searchDrp}
                      onToggle={() => {
                        this.setState((prevState) => ({
                          searchDrp: !prevState.searchDrp,
                        }));
                      }}>
                      <Dropdown.Toggle
                        variant="button"
                        aria-label="Search."
                        className="m-0 p-0 text-decoration-none search-btn"></Dropdown.Toggle>
                      <Dropdown.Menu className="mt-3 rounded-end">
                        <SearchForm
                          toShowCopyOnFocus={false}
                          ifFocusableOnLoad={true}
                          id="drp-nav-search"
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
            <HeaderGlobal />
          </nav>
        </header>
      </>
    );
  }
}

export default HeaderFull;
